<template>
	<div id="app">
		<!-- 顶部栏 -->
		<Header ref="Header"></Header>
		<el-main>
			<router-view></router-view>
		</el-main>
		<!-- 底部栏 -->
		<Footer ref="Footer"></Footer>
	</div>
</template>

<script>
	import Header from '@/components/common/Header'
	import Footer from '@/components/common/Footer'
	import mixins from '@/mixins/index'
	import localStorage from '@/utils/localStorage'
	export default {
		components: {
			Header,
			Footer
		},
		mixins: [mixins],
		data() {
			return {}
		},
		mounted() {
			// 判断登录
			// this.handlogin()
		},
		methods: {
			// 判断登录
			handlogin() {
				let that = this
				if (localStorage.getItem('userInfo') == '' || localStorage.getItem('userInfo') === null) {
					var name = this.$route.name
					if (name != 'index' && name != 'login' && name != 'register' && name != 'success' && name !=
						'forget' && name != 'agreement') {
						this.$router.push({
							name: 'login'
						})
					}
				}
			},
		},
	}
</script>
<style lang="scss" scoped>
	#app {
		display: flex;
		flex-direction: column;
		align-items: center;
		width: 100%;
	}

	/deep/ .el-checkbox__inner {
		width: 20px;
		height: 20px;
	}

	/deep/ .el-checkbox__inner::after {
		height: 11px;
		left: 6px;
		width: 6px;
	}

	// #app::-webkit-scrollbar,
	// body::-webkit-scrollbar {
	// 	display: none;
	// }

	.el-main {
		padding: 0 !important;
		width: 100%;
		background-color: #fff;
	}
	@media (max-width: 600px) {
		#app {
			zoom: 25%;
			overflow-y: auto;
		}
	}
</style>


// WEBPACK FOOTER //
// src/App.vue